import React, { useRef, useState } from 'react';
import axios from 'axios';
import Cookies from 'universal-cookie';
import { useSearchParams } from 'react-router-dom';

export default function ShiftScheduleButton({ role, courseId, school, events, onShifted }) {
  const [busy, setBusy] = useState(false);
  const [feedback, setFeedback] = useState(null);
  const inFlight = useRef(false);
  const [searchParams] = useSearchParams();

  if (role !== 'ADMIN' || !courseId || !searchParams.has('scheduleRepair')) return null;

  async function shiftSchedule() {
    if (inFlight.current || events.length === 0) return;
    setFeedback(null);
    const input = window.prompt(
      `Shift all ${events.length} events in ${school || 'this schedule'} (schedule #${courseId}). ` +
      'Enter whole minutes: positive moves later, negative moves earlier (for example, -60 or +15).',
      '-60',
    );
    if (input === null) return;
    const minutes = Number(input.trim());
    if (!/^[+-]?\d+$/.test(input.trim()) || !Number.isSafeInteger(minutes) || minutes === 0) {
      setFeedback({ error: true, text: 'Enter a non-zero whole number of minutes, for example -60 or +15.' });
      return;
    }
    const movement = `${Math.abs(minutes)} ${Math.abs(minutes) === 1 ? 'minute' : 'minutes'} ${minutes > 0 ? 'later' : 'earlier'}`;
    inFlight.current = true;
    setBusy(true);
    try {
      const cookies = new Cookies();
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/schedule/${courseId}/shift-times?scheduleRepair`,
        { minutes, events: events.map(event => ({
          id: String(event.id), start: event.start.toISOString(), end: event.end.toISOString(),
        })) },
        { headers: { Authorization: `Bearer ${cookies.get('access')}` } },
      );
      await onShifted(response.data.events);
      setFeedback({ error: false, text: `Moved ${response.data.shifted_count} ${response.data.shifted_count === 1 ? 'event' : 'events'} ${movement}.` });
    } catch (error) {
      setFeedback({ error: true, text: error.response?.data?.detail || error.response?.data?.minutes?.[0] ||
        'Unable to confirm the shift. Reload the schedule before trying again.' });
    } finally {
      inFlight.current = false;
      setBusy(false);
    }
  }

  return <div style={{ position: 'fixed', left: 16, bottom: 16, zIndex: 2 }}>
    <button
      type="button"
      aria-label="Shift all events in this schedule"
      onClick={shiftSchedule}
      disabled={busy || events.length === 0}
      className="rounded bg-red-700 px-3 py-2 text-white"
    >{busy ? 'Shifting...' : 'Shift schedule times'}</button>
    {feedback && <p role={feedback.error ? 'alert' : 'status'} className="mt-2 rounded bg-white px-3 py-2 text-sm">
      {feedback.text}
    </p>}
  </div>;
}
